module.exports = __webpack_public_path__ + "img/serve8.cfffff5c.png";